import React from 'react'

import { cn } from '../../lib/utils'

interface IconUserProps {
  className?: string
}

export const IconUser: React.FC<IconUserProps> = ({ className }) => {
  return (
    <svg
      className={cn('w-[20px]', className)}
      viewBox="0 0 10 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4.9987 0.164062C3.39305 0.164062 2.08203 1.47508 2.08203 3.08073C2.08203 4.68638 3.39305 5.9974 4.9987 5.9974C6.60435 5.9974 7.91537 4.68638 7.91537 3.08073C7.91537 1.47508 6.60435 0.164062 4.9987 0.164062ZM4.9987 1.03906C6.13146 1.03906 7.04037 1.94797 7.04037 3.08073C7.04037 4.21349 6.13146 5.1224 4.9987 5.1224C3.86593 5.1224 2.95703 4.21349 2.95703 3.08073C2.95703 1.94797 3.86593 1.03906 4.9987 1.03906ZM1.49243 7.16406C0.856653 7.16406 0.332031 7.68869 0.332031 8.32446V8.76823C0.332031 9.81945 0.996818 10.6326 1.8798 11.1198C2.76278 11.607 3.88106 11.8307 4.9987 11.8307C6.11633 11.8307 7.23461 11.607 8.11759 11.1198C8.87047 10.7044 9.43709 10.0407 9.59587 9.20573H9.66593V8.32446C9.66593 7.68869 9.14074 7.16406 8.50496 7.16406H1.49243ZM1.49243 8.03906H8.50496C8.66777 8.03906 8.79093 8.16166 8.79093 8.32446V8.33073H8.79037V8.76823C8.79037 9.46701 8.39786 9.96633 7.69491 10.3542C6.99195 10.742 5.99565 10.9557 4.9987 10.9557C4.00175 10.9557 3.00545 10.742 2.30249 10.3542C1.59954 9.96633 1.20703 9.46701 1.20703 8.76823V8.32446C1.20703 8.16166 1.32963 8.03906 1.49243 8.03906Z"
        fill="black"
      />
    </svg>
  )
}
